module.exports = __webpack_public_path__ + "assets/retina_TBisectAngleDetailed.4e966d8071acd4b63dc2af5954029d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TBisectAngleDetailed.png
// module id = 729
// module chunks = 0